//@flow
import {
  GET_FEATURES_DONE,
  GET_FEATURES_FAILED,
  GET_FEATURES_INIT,
  SET_FEATURES_DONE,
  SET_FEATURES_FAILED,
  SET_FEATURES_INIT,
  PUBLIC_PERMALINK,
} from "./types";
import { HiverAxios, showMessage } from 'h-commons';

export type FeatureData = {
  title: string,
  feature: string,
  state: "0" | "1" | 0 | 1,
  updated_at: ?string,
  updated_by: ?number,
};
export const getSetFeatures = (data: ?FeatureData) => (dispatch: Function) => {
    dispatch({
        type: data ? SET_FEATURES_INIT : GET_FEATURES_INIT
    });
    let postfix = '';
    if (data) {
        postfix = `/${data.feature}?state=${data.state ? 1 : 0}`;
    }
    HiverAxios({
        url: `/api/account/feature${postfix}`,
        type: data ? 'POST' : 'GET',
        callback: response => {
            if (response.data && response.data.success) {
                if (data) {
                    if(data.feature==PUBLIC_PERMALINK){
                        dispatch({
                          type: SET_FEATURES_DONE,
                          payload: {
                            [data.feature]: {
                              enabled: data.state,
                              updated_at: data.updated_at,
                              updated_by: data.updated_by,
                            },
                          },
                        });
                        data.state && showMessage({ message: `${data.title} can now be enabled for any shared mailbox`, type: 'success' });
                        !data.state && showMessage({ message: `${data.title} are disabled for all shared mailboxes`, type: 'success' });
                    }
                    else{
                        dispatch({
                          type: SET_FEATURES_DONE,
                          payload: { [data.feature]: data.state },
                        });
                        showMessage({ message: `${data.title} feature ${(data.state) ? 'enabled' : 'disabled'}`, type: 'success' });
                    } 
                } 
                else {
                    dispatch({
                        type: GET_FEATURES_DONE,
                        payload: response.data.data
                    });
                }
            } else {
                dispatch({
                    type: data ? SET_FEATURES_FAILED : GET_FEATURES_FAILED
                });
            }
        },
        onfail: err => {
            console.error(err);
            dispatch({
                type: data ? SET_FEATURES_FAILED : GET_FEATURES_FAILED
            });
        }
    })
}